<template>
  <div class="h-auto w-full mr-3 mb-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">List of Companies</p>
      </div>

      <div class="flex justify-between items-center">
        <el-pagination
          background
          @size-change="handleSizeChange"
          :page-sizes="pageSizes"
          :page-index="pageIndex"
          :page-size="pageSize"
          layout="sizes"
          :total="currentTableData.length"
        >
        </el-pagination>
        <!-- search -->
        <input
          v-model="searchInput"
          type="search"
          placeholder="Start typing to search..."
          class="p-2 bg-gray-200 w-52 m-2 py-3 rounded-md"
        />
        <!-- search -->
        <div class="flex flex-wrap justify-end w-full gap-3 pr-3">
          <button
            @click="showCreateLocation = true"
            class="border-1.5 rounded-full px-2 py-1 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex items-center gap-1 capitalize"
          >
            <svg
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              />
            </svg>
            Create
          </button>
        </div>
      </div>

      <div class="px-2 pb-2 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocCrSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showAddDepartmentSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ add_dept_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocDelSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ showLocDelSuccess }}
          </div>
        </transition>

        <div>
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
          />

          <ve-table
            :columns="columns"
            :tableData="currentTableData"
            v-if="!searchInput.length"
          >
          </ve-table>

          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No companies found
          </p>
          <div class="text-center">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
        </div>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <!-- create -->
    <CreateLocation
      @close="handleClose"
      :showCreateLocation="showCreateLocation"
      @closeOnSuccess="handleCloseOnSuccess"
    >
    </CreateLocation>

    <AddDepartment
      @close="handleClose"
      :showAddDepartment="showAddDepartment"
      :selectedRow="selectedRow"
      @closeOnSuccess="handleCloseOnAddDept"
    ></AddDepartment>

    <EditLocation
      @close="handleClose"
      :showEditLocation="showEditLocation"
      :locationToEdit="locationToEdit"
      @closeOnSuccess="handleCloseOnAddDept"
      :reload="reload"
    ></EditLocation>
    <BulkUpload
      v-if="showBulkUpload"
      :close="close"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      :title="title"
      dataType="Companies"
      :url="url"
      :dateColumns="[]"
      :columns="resultColumns"
    ></BulkUpload>
    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>

<script>
import axios from "axios";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";
//import { utils, writeFileXLSX } from "xlsx";
import ActionWarning from "../../../utils/actionWarning.vue";

export default {
  name: "LocationList",
  components: {
    Loader,
    BulkUpload: () => import("@/utils/bulkUploadsUtils.vue"),
    CreateLocation: () =>
      import("@/components/CompanySetups/locations/create.vue"),
    AddDepartment: () =>
      import("@/components/CompanySetups/locations/addDepartments.vue"),
    EditLocation: () =>
      import("@/components/CompanySetups/locations/editLocation.vue"),
    ActionWarning,
  },
  data() {
    return {
      title: "Company",
      url: "",
      showBulkUpload: false,
      showCreateLocation: false,
      showAddDepartment: false,
      loading: false,
      get_error: null,
      linemanagers: [],
      filteredTabs: [],
      selectedRow: null,
      locationDetails: null,
      message: null,
      resultColumns: [],
      showWarning: false,
      locationToDelete: null,
      searchInput: "",
      locationToEdit: {
        Id: "",
        Name: "",
      },
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      showEditLocation: false,
      create_success: "Location created successfully",
      add_dept_success: "Departments have been added successfully",
      del_error: null,
      showLocCrSuccess: false,
      showAddDepartmentSuccess: false,
      showLocDelSuccess: null,
      saved_departments: null,

      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,

          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "name",
          title: "Company Name",
          headerAlign: "left",
          align: "left",
          sampleValue: "Company-01",
        },
        {
          field: "Country",
          key: "country",
          title: "Country",
          headerAlign: "left",
          align: "left",
          sampleValue: "Kenya",
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getLocations();
    this.setPageSizes();
    this.filteredTabs = this.columns.filter(
      (column) => column.title !== "Action"
    );
  },

  methods: {
    close() {
      this.showBulkUpload = false;
      this.$emit("close");
    },
    showBulkUploadForm() {
      this.resultColumns = this.columns.filter((col) => col.title !== "Action");
      this.showBulkUpload = true;
    },
    reload() {
      this.getLocations();
    },
    showBulkUploadCallback() {
      this.showBulkUpload = false;
    },
    setIsConfirmed() {
      this.showWarning = false;
      this.deleteLocation(this.locationToDelete);
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleEditButtonClick(location) {
      // Handle the button click for the edit button
      // //console.log(location);
      this.locationToEdit = {
        LocationId: location.Id,
        Name: location.Name,
        Country: location.Country,
      };
      this.showEditLocation = true;
    },
    handleDeleteButtonClick(location) {
      // Handle the button click for the delete button
      this.message = `You are about to delete ${location.Name}!`;
      this.title = `Delete ${location.Name} in ${location.Country}`;
      this.locationToDelete = location;
      this.showWarning = true;
    },
    handleClose() {
      this.showCreateLocation = false;
      this.showEditLocation = false;
    },
    handleCloseOnSuccess() {
      this.showCreateLocation = false;
      this.showLocCrSuccess = true;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getLocations();
    },

    handleDeleteOnSuccess() {
      setTimeout(() => {
        this.showLocDelSuccess = null;
      }, 3000);
      this.getLocations();
    },

    AddDepartment(row) {
      this.selectedRow = row;
      this.showAddDepartment = true;
    },

    handleCloseOnAddDept() {
      this.showAddDepartment = false;
      this.showAddDepartmentSuccess = true;
      setTimeout(() => {
        this.showAddDepartmentSuccess = false;
      }, 3000);
    },
    getLocations() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.tableData = response.data.Data;
              // //console.log(this.tableData);
              this.tableData.forEach((v, index) => {
                v.rowKey = `${index + ``}`;
                v.departments = [];
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    getDepartments(LocationId, rowIndex) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/location/${LocationId}/departments/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          this.tableData[rowIndex].departments = response.data.Data;
          return true;
        });
    },
    getLinemanagers() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/linemanagers/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;

            if (response.data.StatusCode == 200) {
              this.linemanagers = response.data.Data;
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
    deleteLocation(row) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/setup/location/${row.Id}/v1/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.showLocDelSuccess = response.data.StatusMessage;
              this.handleDeleteOnSuccess();
            } else {
              this.del_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
          }
        );
    },
    exportTemplate() {
      importTemplateGenerator(
        this.filteredTabs,

        "Companies"
      );
    },
  },
};
</script>

<style>
.custom-menu {
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  min-width: 120px;
  padding: 0.5rem 0;
  margin: 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
}
</style>
